import React from 'react';
import classNames from 'classnames';

import Select from '../../components/select';
import TranslationIds from '../../../commons/translationIds';
import countries from '../../../commons/countries';

function renderCountry (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        subscribersFields,
        location,
        touched,
    } = p;

    if (!fields || (!fields.country)) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        if (fields.country === 1) {
            return `${translate(TranslationIds.COMPONENT_COUNTRY)}*`;
        }
        return translate(TranslationIds.COMPONENT_COUNTRY);
    }
 
    function getHelperText () {
        if (fieldErrors.country) {
            return translate(TranslationIds.REGISTRATION_REQUIRED_COUNTRY);
        }

        return;
    }
  
    function getValue () {
        if (!subscribersFields.country) {
            return location?.country_code?.toLowerCase();
        }
        return subscribersFields.country;
    }

    function getData () {
        if(!touched.country) {
            return [
                { label: `${translate(TranslationIds.REGISTRATION_SELECT)} ${translate(TranslationIds.COMPONENT_COUNTRY)}`, value: '-'},
                ...countries,
            ];
        }
        return countries;
    }

    return (
        <Select
            error={fieldErrors.country}
            className={classNames(['ecal-reg-field-country', classes.selectUI])}
            placeHolder={getLabel()}
            helperText={getHelperText()}
            labelHeading={getLabel()}
            value={getValue()}
            dataProvider={getData()}
            onChange={(e, value) => {
                setSubscribersFields({
                    country: value,
                });
            }}
            name={'country'}
        />
    );
}

export default renderCountry;
